// extracted by mini-css-extract-plugin
export default {"page":"p0-z","cartModal":"q0-z","checkout":"r0-z","placeholder":"s0-z","account":"t0-z"};